import { IconShieldCheck } from '@iwoca/icons';
import { Accordion } from '@iwoca/orion';
import { Trans, useLingui } from '@lingui/react/macro';
import { clsx } from 'clsx';

import BankGrid from './BankGrid';
import styles from './BankSelectionModal.module.css';
import { useIsInDEOpenBankingCopyTest } from '../../../../hooks/useIsInDEOpenBankingCopyTest';
import { TOnlineBank } from '../OpenBanking.types';

const BankListViewDE = ({
  banks,
  onSearch,
  searchTerm,
  onBankSelect,
}: {
  onSearch: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onBankSelect: (bank: TOnlineBank) => void;
  banks: TOnlineBank[];
  searchTerm: string;
}) => {
  const { t } = useLingui();
  const { isIncludedInOBCopyTest } = useIsInDEOpenBankingCopyTest();

  return (
    <>
      <div className={styles.bankListDescription}>
        {isIncludedInOBCopyTest ? (
          <Trans>
            Use your bank’s portal to easily and securely share your last 3
            months of account statements. Your login details will not be shared
            with us.
          </Trans>
        ) : (
          <Accordion
            small
            frame={false}
            // @ts-expect-error orion doesn't type `defaultOpen` on the legacy `Accordion`, only on the new `AccordionItem`; it works via headlessui's prop spread
            defaultOpen
            className={styles.accordion}
            titleClassName={styles.bankListTitle}
            title={<Trans>How does it work?</Trans>}
          >
            <p className={styles.accordionBody}>
              <Trans>
                Securely share your bank account’s data. Simply choose your bank
                below and then log in through your bank’s portal when prompted.
              </Trans>
            </p>
          </Accordion>
        )}
        <Accordion
          small
          frame={false}
          // @ts-expect-error orion doesn't type `defaultOpen` on the legacy `Accordion`, only on the new `AccordionItem`; it works via headlessui's prop spread
          defaultOpen
          className={clsx(styles.accordion, styles.accordionWithTopMargin)}
          titleClassName={styles.bankListTitle}
          title={t`Consent to data use`}
        >
          <p className={styles.accordionBody}>
            <Trans>
              By linking your bank account, you explicitly consent to iwoca
              accessing up to 24 months of your transaction data via our partner
              finAPI or TrueLayer, to assess your creditworthiness. You can
              withdraw your consent at any time.
            </Trans>
          </p>
        </Accordion>
        <div className={styles.bankGradeContainer}>
          <IconShieldCheck className={styles.bankGradeIcon} />
          <span>
            <Trans>Bank-grade encryption</Trans>
          </span>
        </div>
      </div>
      <BankGrid
        banks={banks}
        onSearch={onSearch}
        searchTerm={searchTerm}
        onBankSelect={onBankSelect}
      />
    </>
  );
};

export default BankListViewDE;
